// Auto-generated by pipeline
export const firebaseConfig = {
  "authDomain": "moving-girls-4e1e9.firebaseapp.com",
  "projectId": "moving-girls-4e1e9",
  "storageBucket": "moving-girls-4e1e9.firebasestorage.app",
  "messagingSenderId": "113331704431",
  "appId": "1:113331704431:web:ebef00891803b230a5339a",
  "measurementId": "G-1BNF2QCT6H",
  "apiKey": "AIzaSyB6q8rU-P3bfUefObgLn3gUL1B0mDHEfLM"
};
